import React from 'react';
import { KKP_VENTE_WIZARD_STEPS } from '../../utils/kkpVenteBriefUtils';
import { AppButton } from '../ui';

const KkpVenteWizardFooter = ({
  currentStep,
  onStepChange,
  onClose,
  onSave,
  onDelete,
  saving = false,
  deleting = false,
  showDelete = false,
  showCompleteLater = false,
  deleteLabel = 'Supprimer',
  deletingLabel = 'Suppression…',
  deleteVariant = 'outline-danger',
}) => {
  const isFirst = currentStep === 0;
  const isLast = currentStep === KKP_VENTE_WIZARD_STEPS.length - 1;
  const busy = saving || deleting;

  return (
    <div className="kkp-vente-wizard-nav">
      <div>
        {showDelete && (
          <AppButton
            size="sm"
            variant={deleteVariant}
            onClick={onDelete}
            disabled={busy}
            loading={deleting}
            loadingLabel={deletingLabel}
          >
            {deleteLabel}
          </AppButton>
        )}
      </div>
      <span className="kkp-vente-wizard-nav__progress text-secondary-light">
        Étape {currentStep + 1} / {KKP_VENTE_WIZARD_STEPS.length}
      </span>
      <div className="kkp-vente-wizard-nav__actions">
        <AppButton size="sm" variant="outline-secondary" onClick={onClose} disabled={deleting}>
          Annuler
        </AppButton>
        {!isFirst && (
          <AppButton
            size="sm"
            variant="outline-secondary"
            icon="mdi:chevron-left"
            onClick={() => onStepChange(0)}
            disabled={busy}
          >
            Précédent
          </AppButton>
        )}
        {showCompleteLater && (
          <AppButton
            size="sm"
            variant="link"
            className="text-secondary-light text-decoration-none"
            onClick={onSave}
            disabled={busy}
          >
            Compléter plus tard
          </AppButton>
        )}
        <AppButton type="submit" size="sm" variant="success" disabled={busy} loading={saving} loadingLabel="Enregistrement…">
          Enregistrer
        </AppButton>
        {!isLast && (
          <AppButton
            size="sm"
            variant="outline-primary"
            iconClassName="ms-1"
            onClick={() => onStepChange(1)}
            disabled={busy}
          >
            Brief
            <span className="ms-1" aria-hidden>
              ›
            </span>
          </AppButton>
        )}
      </div>
    </div>
  );
};

export default KkpVenteWizardFooter;
